<template>
  <div>
    <div class="row mt-3" v-if="this.videos.length !== 0">
      <div class="col-lg-12 col-xs-12">
        <div class="">
          <div class="card-body-noBorder">
            <div class="row mb-3" v-for="video in this.videos" :key="video.id">
              <div class="col-lg-2 col-xs-12">
                <div class="avatar_thumb_large" @click="showVideo(video.video)">
                  <img class="pointer" :src="video.thumbnail" alt="" />
                </div>
              </div>
              <div class="col-lg-10 col-xs-12 m-0 p-0">
                <h5
                  class="color-primary mt-3 pointer"
                  @click="showVideo(video.video)"
                  v-html="video.title"
                >
                  {{ video.title }}
                </h5>
              </div>
              <hr />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-lg-12 col-xs-12 pt-2" v-if="this.videos.length === 0">
        <div>
          <div class="card-body-noBorder">
            <h3 class="center">NÃO HÁ VÍDEOS PARA MOSTRAR</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Show from "./Show.vue";
export default {
  props: ["candidate_id"],
  data: () => ({
    videos: [],
  }),
  mounted() {
    this.getVideos();
  },
  methods: {
    getVideos() {
      axios
        .get(`/recruiters/talent_banks/${this.candidate_id}/candidate/videos`)
        .then((response) => {
          this.videos = response.data.videos;
        });
    },
    showVideo(url) {
      this.$modal.show(
        Show,
        {
          url,
        },
        {
          width: "50%",
          height: "auto",
          scrollable: false,
        }
      );
    },
  },
};
</script>